<h1 mat-dialog-title>
	<i class="material-icons">warning</i> Alert
</h1>
<div mat-dialog-content>

	<p style="word-break: break-all; overflow-wrap: break-word; white-space: pre-wrap;">{{data.dialogMessage}}</p>

</div>
<div mat-dialog-actions>
	<button
		mat-button
		[mat-dialog-close]=""
		cdkFocusInitial>Ok</button>
</div>
